import { Component, Event, EventEmitter, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'footer-component',
  styleUrl: 'footer-component.scss',
  shadow: true,
})
export class FooterComponent {
  @Event() linkClicked: EventEmitter<string>;
  @Prop() epIconSrcPath: string;
  @Prop() valIconSrcPath: string;
  @Prop() impressUrl: string;

  handleClick(destination: string) {
    this.linkClicked.emit(destination);
  }

  render() {
    return (
      <Host>
        <div class="content">
          <div class="logo-side">
            <div class="text">Ein Service von</div>
            <div class="logos">
              <a href="https://europace.de/">
              <img class="logo" src={this.epIconSrcPath} alt="europaceLogo"></img>
              </a>
              und
              <a href="https://value.ag/">
              <img class="logo" src={this.valIconSrcPath} alt="valueLogo"></img>
              </a>
            </div>
          </div>
          <div class="link-side">
            <a href={this.impressUrl}>Impressum</a>
            <a onClick={() => this.handleClick('datenschutz')}>Datenschutz</a>
            <a onClick={() => this.handleClick('agb')}>AGB</a>
            <a onClick={() => this.handleClick('faq')}>Über uns</a>
          </div>
        </div>
      </Host>
    );
  }
}
